import { render, staticRenderFns } from "./chooseRegistrationModal.vue?vue&type=template&id=bc4b1258&scoped=true&lang=html&"
import script from "./chooseRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./chooseRegistrationModal.vue?vue&type=script&lang=js&"
import style0 from "./chooseRegistrationModal.vue?vue&type=style&index=0&id=bc4b1258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4b1258",
  null
  
)

export default component.exports